import { createSlice, Dispatch, PayloadAction } from '@reduxjs/toolkit';
import { authService } from '../lib/api/auth';
import { UserType } from '../types/auth';
import { tokenManager } from '../lib/token-manager';
import { sessionStorageClearAll } from '../components/storage/sessionStorageManager';
import { localStorageGetItem, localStorageRemoveItem } from '../components/storage/localStorageManager';
import { routes } from '../containers/routes/routes-names';
import { AppDispatch } from './index';
import { useNavigate } from 'react-router-dom';

type InitialStateType = {
    loading: boolean;
    user: UserType | null;
};

const initialState: InitialStateType = {
    loading: true,
    user: null,
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },
        setUser(state, action: PayloadAction<UserType>) {
            state.user = action.payload;
        },
        deleteUser(state) {
            state.user = initialState.user;
            sessionStorageClearAll();
        },
    },
});

export function getUser(navigate: ReturnType<typeof useNavigate>) {
    return async (dispatch: AppDispatch) => {
        try {
            dispatch(userSlice.actions.setLoading(true));
            const user = await authService.getUser();
            if (user.resultObject.suspendedStatus === 1 || user.resultObject.joinStatus === 2) {
                signOutForceFully(navigate);
            }

            if (user) {
                dispatch(userSlice.actions.setUser(user.resultObject));
            }
        } catch (err) {
          dispatch(userSlice.actions.deleteUser());
          tokenManager.removeToken();
        } finally {
            dispatch(userSlice.actions.setLoading(false));
        }
    };
}

export function signOut(navigate: ReturnType<typeof useNavigate>) {
    const unClaimedCandidateRouteInternal = localStorageGetItem('claimedType', true)!;
    return async (dispatch: Dispatch) => {
        dispatch(userSlice.actions.deleteUser());
        tokenManager.removeToken();
        localStorageRemoveItem('userApiToBeRun');
        localStorageRemoveItem('hrmsuserApiToBeRun');
        localStorageRemoveItem('recentSearch-id');
        localStorageRemoveItem('seosearch');
        // history.push(routes.main);
        if (unClaimedCandidateRouteInternal === 'company') {
            navigate(routes.signUp, {
                state: {
                    data: {
                        claimedType: 'company',
                    },
                },
            });
        } else {
            navigate(routes.main);
        }
    };
}

export function signOutForceFully(navigate: ReturnType<typeof useNavigate>) {
    userSlice.actions.deleteUser();
    tokenManager.removeToken();
    localStorageRemoveItem('userApiToBeRun');
    localStorageRemoveItem('hrmsuserApiToBeRun');
    navigate(routes.main);
    localStorageRemoveItem('seosearch');
    window.location.reload();
}

export function linkedInSignOut() {
    return async (dispatch: AppDispatch) => {
        const linkedInSignOut = (url: any) => {
            const win = window.open(
                url,
                '_blank',
                'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,left=10000, top=10000, width=5, height=5, visible=none'
            );
            setTimeout(() => {
                win?.close();
            }, 3000);
        };
        linkedInSignOut(`https://linkedin.com/m/logout`);
        dispatch(userSlice.actions.deleteUser());
        tokenManager.removeToken();
    };
}

export default userSlice.reducer;
export const { setLoading } = userSlice.actions;
